import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import { isEmpty } from 'utils/validations'
import * as featureCheckActions from 'action/featureCheck'
import ContentHeader from 'component/utils/ContentHeader'
import FeatureCheckTable from 'component/featureCheck/Table'
import FeatureCheckEditForm from 'component/featureCheck/EditForm'
import Notification from 'component/utils/Notification'
import Col from 'component/utils/Col'
import Breadcrumb from 'component/Breadcrumb'

class FeatureCheckContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    execute: PropTypes.func.isRequired,
    error: PropTypes.object,
    interfaceCheckData: PropTypes.object,
    updated: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.renderNotification = this.renderNotification.bind(this)
  }

  handleSubmit(toSave) {
    const {
      execute,
      auth: { user },
    } = this.props

    execute(toSave, user.dsToken)
  }

  renderNotification() {
    const { translate } = this.props
    return (
      <Notification
        className='notification-warning notification-warning-mission margin-top'
        message={translate('feature-check.not-found')}
      />
    )
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('feature-check.title') },
      { title: translate('feature-check.submenu') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const { translate, error, auth, interfaceCheckData } = this.props

    const initialValues = {}

    return (
      <section>
        <ContentHeader>{translate('feature-check.title')}</ContentHeader>
        <div className='feature-check-page'>
          {this.renderBreadcrumb()}

          <div className='container-fluid'>
            {
              // shows notification after an update
              error && error.fields ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.fields.map(this.renderFieldsErrors)}
                </div>
              ) : error ? (
                <div className='margin-top margin-botton notification notification-warning'>
                  {error.message.dsMessage}
                </div>
              ) : (
                ''
              )
            }
          </div>

          <section className='container-mobile container-flex'>
            <Col xs={12} sm={12} md={3} className='show-fourth-on-mobile'>
              <FeatureCheckEditForm
                translate={translate}
                onSubmit={this.handleSubmit}
                initialValues={initialValues}
                error={error}
                auth={auth}
              />
            </Col>

            <Col xs={12} sm={12} md={9} className='show-first-on-mobile'>
              {isEmpty(interfaceCheckData) ? (
                this.renderNotification()
              ) : (
                <FeatureCheckTable
                  translate={translate}
                  interfaceCheckData={interfaceCheckData}
                />
              )}
            </Col>
          </section>
        </div>
      </section>
    )
  }
}

const mapStateToProps = ({ featureCheckReducer }) => ({
    interfaceCheckData: featureCheckReducer.data,
  })

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(featureCheckActions, dispatch)

/*
 * Connects component to I18next
 */
const FeatureCheckTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(FeatureCheckContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureCheckTranslated)

/*
 * Exports as component
 */
export { FeatureCheckContainer as FeatureCheck }
